module.exports = __webpack_public_path__ + "static/media/1POLICY19.2f820da8.jpg";